export default "__VITE_ASSET__fL90jSew__"